'use client';

const qualityObjectives = [
  {
    num: '01',
    icon: 'fas fa-smile',
    title: 'Accueil Satisfaisant des Patients',
    desc: 'Garantir un accueil chaleureux, respectueux et professionnel à chaque patient dès son arrivée au centre médical COSA Ananeraie.',
  },
  {
    num: '02',
    icon: 'fas fa-user-md',
    title: 'Améliorer la Prise en Charge',
    desc: 'Optimiser continuellement les protocoles de soins pour assurer une prise en charge rapide, efficace et personnalisée de chaque patient.',
  },
  {
    num: '03',
    icon: 'fas fa-shield-alt',
    title: 'Sécurité des Patients',
    desc: 'Mettre en place des procédures rigoureuses pour prévenir les risques médicaux et garantir la sécurité de chaque patient tout au long de son parcours de soins.',
  },
  {
    num: '04',
    icon: 'fas fa-cogs',
    title: 'Système de Management de la Qualité (SMQ)',
    desc: 'Disposer et maintenir un SMQ conforme aux normes internationales pour piloter l\'amélioration continue de nos processus et performances.',
  },
  {
    num: '05',
    icon: 'fas fa-handshake',
    title: 'Satisfaction des Parties Intéressées',
    desc: 'Améliorer la satisfaction de l\'ensemble de nos parties prenantes : patients, familles, partenaires, assureurs et collaborateurs.',
  },
];

export default function QualityPolicySection() {
  return (
    <section className="py-20" style={{ backgroundColor: '#f8fdf9' }}>
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-widest mb-3 block" style={{ color: '#fbaf45' }}>
            Engagement Qualité
          </span>
          <h2 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Notre Politique Qualité
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed">
            COSA Ananeraie s'engage à fournir des soins de santé conformes aux plus hauts standards internationaux. Notre politique qualité repose sur cinq objectifs fondamentaux.
          </p>
        </div>

        {/* Objectives — asymmetric bento layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {qualityObjectives?.map((obj, i) => (
            <div
              key={i}
              className={`rounded-2xl p-8 relative overflow-hidden transition-all hover:shadow-xl hover:-translate-y-1 ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`}
              style={{
                backgroundColor: i % 2 === 0 ? '#fff' : '#0e5932',
                border: i % 2 === 0 ? '2px solid #0e593215' : 'none',
              }}
            >
              {/* Background number */}
              <div
                className="absolute top-4 right-6 text-7xl font-black opacity-10 select-none"
                style={{ color: i % 2 === 0 ? '#0e5932' : '#fff', fontFamily: 'Lato, sans-serif' }}
              >
                {obj?.num}
              </div>

              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center text-xl mb-5"
                style={{
                  backgroundColor: i % 2 === 0 ? '#0e593215' : 'rgba(255,255,255,0.15)',
                  color: i % 2 === 0 ? '#0e5932' : '#fbaf45',
                }}
              >
                <i className={obj?.icon}></i>
              </div>

              <h3
                className="font-black text-lg mb-3"
                style={{ color: i % 2 === 0 ? '#1d3c5e' : '#fff', fontFamily: 'Lato, sans-serif' }}
              >
                {obj?.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: i % 2 === 0 ? '#6b7280' : 'rgba(255,255,255,0.8)' }}
              >
                {obj?.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div
          className="mt-12 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6"
          style={{ backgroundColor: '#fbaf45' }}
        >
          <div>
            <h3 className="font-black text-xl mb-2" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
              Certifié & Accrédité
            </h3>
            <p className="text-sm" style={{ color: '#1d3c5e', opacity: 0.8 }}>
              COSA Ananeraie s'inscrit dans une démarche d'accréditation continue conforme aux standards de l'OMS et des autorités sanitaires ivoiriennes.
            </p>
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <div className="text-center">
              <i className="fas fa-award text-3xl" style={{ color: '#0e5932' }}></i>
              <div className="text-xs font-bold mt-1" style={{ color: '#1d3c5e' }}>ISO 9001</div>
            </div>
            <div className="text-center">
              <i className="fas fa-certificate text-3xl" style={{ color: '#0e5932' }}></i>
              <div className="text-xs font-bold mt-1" style={{ color: '#1d3c5e' }}>Accrédité</div>
            </div>
            <div className="text-center">
              <i className="fas fa-star text-3xl" style={{ color: '#0e5932' }}></i>
              <div className="text-xs font-bold mt-1" style={{ color: '#1d3c5e' }}>Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
